import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'

@Injectable()
export class DashboardOverviewEffects {
  constructor(private actions$: Actions) {}
}
